import { render } from "./UnsubscribeNotification.vue?vue&type=template&id=38d7777d"
import script from "./UnsubscribeNotification.vue?vue&type=script&lang=js"
export * from "./UnsubscribeNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__